module.exports = __webpack_public_path__ + "static/media/img-auth-big.db92846c.jpg";